import {
  FileArchive,
  FileAudio,
  FileCode,
  FileImage,
  FileJson,
  FileSpreadsheet,
  FileText,
  FileVideo,
  File as FileIcon,
} from 'lucide-react';
import { categorizePreview } from './mime';

function ext(path: string): string {
  const base = path.split('/').pop() ?? path;
  const dot = base.lastIndexOf('.');
  return dot <= 0 ? '' : base.slice(dot + 1).toLowerCase();
}

/**
 * A type-aware file icon. Colors are muted-but-distinct so the tree reads as a
 * real file explorer, not a wall of identical grey glyphs.
 */
export function FileTypeIcon({ path, mime, className }: { path: string; mime?: string; className?: string }) {
  const cls = className ?? 'size-4 shrink-0';
  const e = ext(path);
  const kind = categorizePreview(mime, path);

  if (e === 'json' || e === 'jsonc') return <FileJson className={`${cls} text-amber-400`} />;
  if (['zip', 'tar', 'gz', 'tgz', 'rar', '7z'].includes(e)) return <FileArchive className={`${cls} text-yellow-500`} />;

  switch (kind) {
    case 'code':
      return <FileCode className={`${cls} text-sky-400`} />;
    case 'markdown':
      return <FileText className={`${cls} text-indigo-300`} />;
    case 'html':
      return <FileCode className={`${cls} text-orange-400`} />;
    case 'image':
      return <FileImage className={`${cls} text-emerald-400`} />;
    case 'video':
      return <FileVideo className={`${cls} text-fuchsia-400`} />;
    case 'audio':
      return <FileAudio className={`${cls} text-pink-400`} />;
    case 'csv':
      return <FileSpreadsheet className={`${cls} text-green-400`} />;
    case 'pdf':
      return <FileText className={`${cls} text-red-400`} />;
    default:
      return <FileIcon className={`${cls} text-muted-foreground`} />;
  }
}
